import { Vendor } from "./Vendor";

export const INITIAL_VALUES: Vendor = {
	vendorId: 0,
	vendorName: "",
	nsblVendorId: 0,
	isActive: true,
};
